
import { http } from './api'

const resource = 'cargo-especialidade'

export default {
    
    obterEspecialidadesDoCargo:(dados) => {
        return http.post(`${resource}/especialidades-do-cargo`, dados)
    },
    obterConfiguracaoEspecialidadeAtuacao:(aatcargo, mmtcargo, cdgcargo, cdcargo, cdespecia) => {
        return http.get(`${resource}/configuracoes-cargo-especialidade/${aatcargo}/${mmtcargo}/${cdgcargo}/${cdcargo}/${cdespecia}`)
    },
    salvar(dados) {
        return http.post(`${resource}/salvar`, dados)
    },
    excluir(aatcargoef,mmtcargoef,cdgcargoef,cdcargoef,cdespecia,cddiscipl) {
        return http.delete(`${resource}/excluir/${aatcargoef}/${mmtcargoef}/${cdgcargoef}/${cdcargoef}/${cdespecia}/${cddiscipl}`)
    }


    
}

